import React, {Component} from "react";
import { Modal as ModalRs, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import TimeInput from "../../helper/time_input";
import Swal from "sweetalert2";

class TambahJamker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nama_sift: '',
            sift_tolerance: '',
            senin_jam_masuk: '',
            senin_jam_keluar: '',
            selasa_jam_masuk: '',
            selasa_jam_keluar: '',
            rabu_jam_masuk: '',
            rabu_jam_keluar: '',
            kamis_jam_masuk: '',
            kamis_jam_keluar: '',
            jumat_jam_masuk: '',
            jumat_jam_keluar: '',
            sabtu_jam_masuk: '',
            sabtu_jam_keluar: '',
            minggu_jam_masuk: '',
            minggu_jam_keluar: '',
            loading: false,
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }

    handleAddJamKer = () =>  {
        this.setState({ loading: true })
        let form = {
            sift_nama: this.state.nama_sift,
            tolerance: this.state.sift_tolerance,
            senin_in: this.state.senin_jam_masuk,
            senin_out: this.state.senin_jam_keluar,
            selasa_in: this.state.selasa_jam_masuk,
            selasa_out: this.state.selasa_jam_keluar,
            rabu_in: this.state.rabu_jam_masuk,
            rabu_out: this.state.rabu_jam_keluar,
            kamis_in: this.state.kamis_jam_masuk,
            kamis_out: this.state.kamis_jam_keluar,
            jumat_in: this.state.jumat_jam_masuk,
            jumat_out: this.state.jumat_jam_keluar,
            sabtu_in: this.state.sabtu_jam_masuk,
            sabtu_out: this.state.sabtu_jam_keluar,
            minggu_in: this.state.minggu_jam_masuk,
            minggu_out: this.state.minggu_jam_keluar
        }
        this.props.request('jamKerja/tambah-jamker', form, 'POST')
            .then((response) => {
                this.props.changeState({ add_visible: false, data: [], loading: true }, () => this.props.loadData())
                Swal.fire({
                    title: response && response.success ? 'Berhasil!' : 'Gagal!',
                    text: response && response.message,
                    icon: response && response.success ? 'success' : 'error',
                    showConfirmButton: false,
                    timer: 1500,
                });
                this.setState({ loading: false })
                if (response && response.success) {
                    this.setState({
                        nama_sift: '',
                        sift_tolerance: '',
                        senin_jam_masuk: '',
                        senin_jam_keluar: '',
                        selasa_jam_masuk: '',
                        selasa_jam_keluar: '',
                        rabu_jam_masuk: '',
                        rabu_jam_keluar: '',
                        kamis_jam_masuk: '',
                        kamis_jam_keluar: '',
                        jumat_jam_masuk: '',
                        jumat_jam_keluar: '',
                        sabtu_jam_masuk: '',
                        sabtu_jam_keluar: '',
                        minggu_jam_masuk: '',
                        minggu_jam_keluar: '',
                    });
                }
            })
    }

    render() {
        const style_add = {
            card_header: {
                backgroundColor: "#FAFDFF",
                padding: "10px 16px",
                color: "#143B5E",
                fontSize: "16px",
                fontWeight: 500,
                lineHeight: "24px",
                borderRadius: "4px",
            },
            hari: {
                color: "#143B5E",
                fontSize: "16px",
                fontWeight: 500,
                marginLeft: "4px"
            }
        }
        return (
            <ModalRs size="lg" zIndex={999} style={{ marginRight: "0px", maxWidth: "419px", marginTop: '0px' }} isOpen={this.props.add_visible} toggle={() => this.props.changeState({ add_visible: false })}>
                <ModalHeader style={{ backgroundColor: "#FAFDFF" }} toggle={() => this.props.changeState({ add_visible: false })}>
                    <div className="modal-header-reactstra font-weight-bold">Tambah Jam Kerja</div>
                </ModalHeader>
                <ModalBody>
                    <div>
                        <div className="form-group">
                            <label htmlFor="nama_sift">Nama Shift</label>
                            <input type="text" className="form-control" name="nama_sift" id="nama_sift" placeholder="Nama Shift" autoComplete="false"
                                   onChange={this.handleChange}/>
                        </div>
                        <div className="form-group">
                            <label htmlFor="sift_tolerance">Toleransi Terlambat (Menit)</label>
                            <input type="number" className="form-control" name="sift_tolerance" id="sift_tolerance" placeholder="Toleransi Terlambat" autoComplete="false"
                                   onChange={this.handleChange}/>
                        </div>
                        <div className="d-flex flex-column" style={{ gap: 10 }}>
                            <div className='card-header p-0 border' style={style_add.card_header}>
                                <div style={style_add.hari}>
                                    Senin
                                </div>
                                <div className='row d-flex flex-nowrap m-0 px-3'>
                                    <div className='mb-1'>
                                        <label htmlFor="exampleFormControlInput1"
                                               className="form-label font-edit-label-2 ml-1">Jam
                                            Masuk</label>
                                        <TimeInput
                                            style={{fontSize: "12px"}}
                                            initTime={this.state.senin_jam_masuk !== null &&
                                            this.state.senin_jam_masuk !== undefined
                                                ? this.state.senin_jam_masuk.substr(0, 5) : ''}
                                            className='s-input -time form-control px-3 py-2'
                                            onTimeChange={(event) => {
                                                const value = event;
                                                this.setState({
                                                    senin_jam_masuk: value + ':00'
                                                })
                                            }}
                                        />
                                    </div>
                                    <div className='mb-3'>
                                        <label htmlFor="exampleFormControlInput1"
                                               className="form-label font-edit-label-2 ml-3">
                                            Jam Keluar
                                        </label>
                                        <TimeInput
                                            style={{fontSize: "12px", marginLeft: '12px'}}
                                            initTime={this.state.senin_jam_keluar !== null &&
                                            this.state.senin_jam_keluar !== undefined
                                                ? this.state.senin_jam_keluar.substr(0, 5) : ''}
                                            className='s-input -time form-control px-3 py-2'
                                            onTimeChange={(event) => {
                                                const value = event;
                                                this.setState({
                                                    senin_jam_keluar: value + ':00'
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='card-header p-0 border' style={style_add.card_header}>
                                <div style={style_add.hari}>
                                    Selasa
                                </div>
                                <div className='row d-flex flex-nowrap m-0 px-3'>
                                    <div className='mb-1'>
                                        <label htmlFor="exampleFormControlInput1"
                                               className="form-label font-edit-label-2 ml-1">Jam
                                            Masuk</label>
                                        <TimeInput
                                            style={{fontSize: "12px"}}
                                            initTime={this.state.selasa_jam_masuk !== null &&
                                            this.state.selasa_jam_masuk !== undefined
                                                ? this.state.selasa_jam_masuk.substr(0, 5) : ''}
                                            className='s-input -time form-control px-3 py-2'
                                            onTimeChange={(event) => {
                                                const value = event;
                                                this.setState({
                                                    selasa_jam_masuk: value + ':00'
                                                })
                                            }}
                                        />
                                    </div>
                                    <div className='mb-3'>
                                        <label htmlFor="exampleFormControlInput1"
                                               className="form-label font-edit-label-2 ml-3">
                                            Jam Keluar
                                        </label>
                                        <TimeInput
                                            style={{fontSize: "12px", marginLeft: '12px'}}
                                            initTime={this.state.selasa_jam_keluar !== null &&
                                            this.state.selasa_jam_keluar !== undefined
                                                ? this.state.selasa_jam_keluar.substr(0, 5) : ''}
                                            className='s-input -time form-control px-3 py-2'
                                            onTimeChange={(event) => {
                                                const value = event;
                                                this.setState({
                                                    selasa_jam_keluar: value + ':00'
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='card-header p-0 border' style={style_add.card_header}>
                                <div style={style_add.hari}>
                                    Rabu
                                </div>
                                <div className='row d-flex flex-nowrap m-0 px-3'>
                                    <div className='mb-1'>
                                        <label htmlFor="exampleFormControlInput1"
                                               className="form-label font-edit-label-2 ml-1">Jam
                                            Masuk</label>
                                        <TimeInput
                                            style={{fontSize: "12px"}}
                                            initTime={this.state.rabu_jam_masuk !== null &&
                                            this.state.rabu_jam_masuk !== undefined
                                                ? this.state.rabu_jam_masuk.substr(0, 5) : ''}
                                            className='s-input -time form-control px-3 py-2'
                                            onTimeChange={(event) => {
                                                const value = event;
                                                this.setState({
                                                    rabu_jam_masuk: value + ':00'
                                                })
                                            }}
                                        />
                                    </div>
                                    <div className='mb-3'>
                                        <label htmlFor="exampleFormControlInput1"
                                               className="form-label font-edit-label-2 ml-3">
                                            Jam Keluar
                                        </label>
                                        <TimeInput
                                            style={{fontSize: "12px", marginLeft: '12px'}}
                                            initTime={this.state.rabu_jam_keluar !== null &&
                                            this.state.rabu_jam_keluar !== undefined
                                                ? this.state.rabu_jam_keluar.substr(0, 5) : ''}
                                            className='s-input -time form-control px-3 py-2'
                                            onTimeChange={(event) => {
                                                const value = event;
                                                this.setState({
                                                    rabu_jam_keluar: value + ':00'
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='card-header p-0 border' style={style_add.card_header}>
                                <div style={style_add.hari}>
                                    Kamis
                                </div>
                                <div className='row d-flex flex-nowrap m-0 px-3'>
                                    <div className='mb-1'>
                                        <label htmlFor="exampleFormControlInput1"
                                               className="form-label font-edit-label-2 ml-1">Jam
                                            Masuk</label>
                                        <TimeInput
                                            style={{fontSize: "12px"}}
                                            initTime={this.state.kamis_jam_masuk !== null &&
                                            this.state.kamis_jam_masuk !== undefined
                                                ? this.state.kamis_jam_masuk.substr(0, 5) : ''}
                                            className='s-input -time form-control px-3 py-2'
                                            onTimeChange={(event) => {
                                                const value = event;
                                                this.setState({
                                                    kamis_jam_masuk: value + ':00'
                                                })
                                            }}
                                        />
                                    </div>
                                    <div className='mb-3'>
                                        <label htmlFor="exampleFormControlInput1"
                                               className="form-label font-edit-label-2 ml-3">
                                            Jam Keluar
                                        </label>
                                        <TimeInput
                                            style={{fontSize: "12px", marginLeft: '12px'}}
                                            initTime={this.state.kamis_jam_keluar !== null &&
                                            this.state.kamis_jam_keluar !== undefined
                                                ? this.state.kamis_jam_keluar.substr(0, 5) : ''}
                                            className='s-input -time form-control px-3 py-2'
                                            onTimeChange={(event) => {
                                                const value = event;
                                                this.setState({
                                                    kamis_jam_keluar: value + ':00'
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='card-header p-0 border' style={style_add.card_header}>
                                <div style={style_add.hari}>
                                    Jumat
                                </div>
                                <div className='row d-flex flex-nowrap m-0 px-3'>
                                    <div className='mb-1'>
                                        <label htmlFor="exampleFormControlInput1"
                                               className="form-label font-edit-label-2 ml-1">Jam
                                            Masuk</label>
                                        <TimeInput
                                            style={{fontSize: "12px"}}
                                            initTime={this.state.jumat_jam_masuk !== null &&
                                            this.state.jumat_jam_masuk !== undefined
                                                ? this.state.jumat_jam_masuk.substr(0, 5) : ''}
                                            className='s-input -time form-control px-3 py-2'
                                            onTimeChange={(event) => {
                                                const value = event;
                                                this.setState({
                                                    jumat_jam_masuk: value + ':00'
                                                })
                                            }}
                                        />
                                    </div>
                                    <div className='mb-3'>
                                        <label htmlFor="exampleFormControlInput1"
                                               className="form-label font-edit-label-2 ml-3">
                                            Jam Keluar
                                        </label>
                                        <TimeInput
                                            style={{fontSize: "12px", marginLeft: '12px'}}
                                            initTime={this.state.jumat_jam_keluar !== null &&
                                            this.state.jumat_jam_keluar !== undefined
                                                ? this.state.jumat_jam_keluar.substr(0, 5) : ''}
                                            className='s-input -time form-control px-3 py-2'
                                            onTimeChange={(event) => {
                                                const value = event;
                                                this.setState({
                                                    jumat_jam_keluar: value + ':00'
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='card-header p-0 border' style={style_add.card_header}>
                                <div style={style_add.hari}>
                                    Sabtu
                                </div>
                                <div className='row d-flex flex-nowrap m-0 px-3'>
                                    <div className='mb-1'>
                                        <label htmlFor="exampleFormControlInput1"
                                               className="form-label font-edit-label-2 ml-1">Jam
                                            Masuk</label>
                                        <TimeInput
                                            style={{fontSize: "12px"}}
                                            initTime={this.state.sabtu_jam_masuk !== null &&
                                            this.state.sabtu_jam_masuk !== undefined
                                                ? this.state.sabtu_jam_masuk.substr(0, 5) : ''}
                                            className='s-input -time form-control px-3 py-2'
                                            onTimeChange={(event) => {
                                                const value = event;
                                                this.setState({
                                                    sabtu_jam_masuk: value + ':00'
                                                })
                                            }}
                                        />
                                    </div>
                                    <div className='mb-3'>
                                        <label htmlFor="exampleFormControlInput1"
                                               className="form-label font-edit-label-2 ml-3">
                                            Jam Keluar
                                        </label>
                                        <TimeInput
                                            style={{fontSize: "12px", marginLeft: '12px'}}
                                            initTime={this.state.sabtu_jam_keluar !== null &&
                                            this.state.sabtu_jam_keluar !== undefined
                                                ? this.state.sabtu_jam_keluar.substr(0, 5) : ''}
                                            className='s-input -time form-control px-3 py-2'
                                            onTimeChange={(event) => {
                                                const value = event;
                                                this.setState({
                                                    sabtu_jam_keluar: value + ':00'
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='card-header p-0 border' style={style_add.card_header}>
                                <div style={style_add.hari}>
                                    Minggu
                                </div>
                                <div className='row d-flex flex-nowrap m-0 px-3'>
                                    <div className='mb-1'>
                                        <label htmlFor="exampleFormControlInput1"
                                               className="form-label font-edit-label-2 ml-1">Jam
                                            Masuk</label>
                                        <TimeInput
                                            style={{fontSize: "12px"}}
                                            initTime={this.state.minggu_jam_masuk !== null &&
                                            this.state.minggu_jam_masuk !== undefined
                                                ? this.state.minggu_jam_masuk.substr(0, 5) : ''}
                                            className='s-input -time form-control px-3 py-2'
                                            onTimeChange={(event) => {
                                                const value = event;
                                                this.setState({
                                                    minggu_jam_masuk: value + ':00'
                                                })
                                            }}
                                        />
                                    </div>
                                    <div className='mb-3'>
                                        <label htmlFor="exampleFormControlInput1"
                                               className="form-label font-edit-label-2 ml-3">
                                            Jam Keluar
                                        </label>
                                        <TimeInput
                                            style={{fontSize: "12px", marginLeft: '12px'}}
                                            initTime={this.state.minggu_jam_keluar !== null &&
                                            this.state.minggu_jam_keluar !== undefined
                                                ? this.state.minggu_jam_keluar.substr(0, 5) : ''}
                                            className='s-input -time form-control px-3 py-2'
                                            onTimeChange={(event) => {
                                                const value = event;
                                                this.setState({
                                                    minggu_jam_keluar: value + ':00'
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div>
                        <button className="btn-sm izin-tolak-button" onClick={() => this.props.changeState({ add_visible: false })}>Batal</button>
                        <button className="btn btn-primary tambah-absen" onClick={this.handleAddJamKer} disabled={this.state.loading}>
                            {this.state.loading ? "Loading..." : "Simpan"}
                        </button>
                    </div>
                </ModalFooter>
            </ModalRs>
        )
    }
}

export default TambahJamker;